import React, { useEffect, useState } from "react";
import { InputHLPure, SimpleLoading, FormError, TextAreaHLPure, DropDownBtnHLPure, Traslates, FormDatePicker, ButtonHLPure, DialogSystemGLPure } from "../../pures";
import { useTranslation } from "react-i18next";
import { countriesList } from "../../../utils";
import "./registration-freelance-data.css"

const RegistrationFreelanceDataView = (props) => {

    let {
        validator,
        toggleCompletedRequesting,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        showLoadingRequesting,
        showErrorRequesting,
        showCompletedRequesting,
        messageError,
        handleSaveData,
        onHandleNext,
        onHandleBack,
        step,
        freelanceData,
        getFreelanceData
    } = props

    const { t } = useTranslation();

    const[name, setName] = useState('')
    const[lastname, setLastname] = useState('')
    const[secondLastName, setSecondLastName] = useState('')
    const[rfc, setRfc] = useState('')
    const[curp, setCurp] = useState('')
    const[address, setAddress] = useState('')
    const[birthPlace, setBirthPlace] = useState('')
    const[country, setCountry] = useState('México')
    const[nationality, setNationality] = useState('')
    const[date, setDate] = useState('')
    const[passport, setPassport] = useState('')
    const[city, setCity] = useState('')
    const[state, setState] = useState('')
    const[cp, setCp] = useState('')
    const[errorName, setErrorName] = useState(false)
    const[errorLastname, setErrortLastname] = useState(false)
    const[errorSecondLastname, setErrorSecondLastname] = useState(false)
    const[errorRfc, setErrorRfc] = useState(false)
    const[errorCurp, setErrorCurp] = useState(false)

    useEffect(() => {
        getFreelanceData() 
    },[])

    useEffect(() => {
        if(!freelanceData) return
        setName(freelanceData.name)
        setLastname(freelanceData.lastname)
        setSecondLastName(freelanceData.secondLastname)
        setRfc(freelanceData.rfc)
        setAddress(freelanceData.address)
        setCurp(freelanceData.curp)
        setBirthPlace(freelanceData.birthPlace)
        setNationality(freelanceData.nationality)
        setDate(freelanceData.date)
        setPassport(freelanceData.passport) 
        setCountry(freelanceData.passportCountry) 
        setCity(freelanceData.city)
        setState(freelanceData.state)
        setCp(freelanceData.cp)
    },[freelanceData])

    const onChangeInput = (e, setValue, setErrorInput) => {
        setValue(e.target.value)
        if(setErrorInput){
            setErrorInput(false)
        }
    }
    
    const onBlurInput = (value, validatorValue, setError) => {
        if(value){
            let valueValidated = validator[validatorValue](value)
            if(valueValidated && setError){
                setError(true)
            }
        }
    }

    const handleSaveInfo = () => {
        if(!name){
            toggleErrorRequesting(true, 4000, 'Agregar un nombre')
            return
        }

 
        let fullname = `${name || '---'}${lastname || ""}${secondLastName || ""}`
        let data = {
            name,
            firstLastName: lastname,
            secondLastName,
            rfc,
            curp,
            address,
            city,
            state,
            zip: cp,
            passportnumber: (passport || null),
            countrypassport: country,
            placeofbirth: birthPlace,
            nacionality: nationality,
            birthdate: date,
            fullname,
        }

        handleSaveData(data, onHandleNext)
    }

    if(showLoadingRequesting) return <SimpleLoading />

    return (
        <div className="registrationFreelanceDataView-container">
            <div className="registrationFreelanceDataView-data">
                <div className="registrationFreelanceDataView-left">
                    <div>
                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.name")}
                            valueInput={name}
                            handleChangeInput={(e) => onChangeInput(e, setName, setErrorName)}
                            // tooltipShow
                            // positionTooltip={'right'}
                            // titleTooltip={"Nombre completo"}
                            // descriptionTooltip={"Nombre"}
                            // subContent={''}
                            // informationIcon={true}
                            inputActive={true}
                            onBlur={() => onBlurInput(name, 'nameValidator', setErrorName)}
                        />
                        {
                            errorName && (
                                <FormError
                                    message={t('registration.validator.nameValidator')}
                                />
                            )
                        }
                    </div>
                    <div className="registrationFreelanceDataView-lastname">

                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.first.lastname")}
                            valueInput={lastname}
                            handleChangeInput={(e) => onChangeInput(e, setLastname, setErrortLastname)}
                            // tooltipShow
                            // positionTooltip={'right'}
                            // titleTooltip={"Nombre completo"}
                            // descriptionTooltip={"Nombre"}
                            // subContent={''}
                            // informationIcon={true}
                            inputActive={true}
                            onBlur={() => onBlurInput(lastname, 'firstLastNameValidator', setErrortLastname)}
                        />
                        {
                            errorLastname && (
                                <FormError
                                    message={t('registration.validator.firstLastNameValidator')}
                                />
                            )
                        }
                    </div>
                    <div className="registrationFreelanceDataView-secondLastname">
                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.second.lastname")}
                            valueInput={secondLastName}
                            handleChangeInput={(e) => onChangeInput(e, setSecondLastName, setErrorSecondLastname)}
                            // tooltipShow
                            // positionTooltip={'right'}
                            // titleTooltip={"Nombre completo"}
                            // descriptionTooltip={"Nombre"}
                            // subContent={''}
                            // informationIcon={true}
                            inputActive={true}
                            onBlur={() => onBlurInput(secondLastName, 'secondLastNameValidator', setErrorSecondLastname)}
                            
                        />        
                        {
                            errorSecondLastname && (
                                <FormError
                                    message={t('registration.validator.secondLastNameValidator')}
                                />
                            )
                        }        
                    </div>
                    <div className="registrationFreelanceDataView-rfc">
                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.rfc")}
                            valueInput={rfc}
                            handleChangeInput={(e) => onChangeInput(e, setRfc, setErrorRfc)}
                            // tooltipShow
                            // positionTooltip={'right'}
                            // titleTooltip={"Nombre completo"}
                            // descriptionTooltip={"Nombre"}
                            // subContent={''}
                            // informationIcon={true}
                            inputActive={true}
                            onBlur={() => onBlurInput(rfc, 'rfcValidator', setErrorRfc)}
                            
                        />        
                        {
                            errorRfc && (
                                <FormError
                                    message={t('registration.validator.rfcValidato')}
                                />
                            )
                        }        
                    </div>
                    <div>
                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.curp")}
                            valueInput={curp}
                            handleChangeInput={(e) => onChangeInput(e, setCurp, setErrorCurp)}
                            // tooltipShow
                            // positionTooltip={'right'}
                            // titleTooltip={"Nombre completo"}
                            // descriptionTooltip={"Nombre"}
                            // subContent={''}
                            // informationIcon={true}
                            inputActive={true}
                            onBlur={() => onBlurInput(curp, 'curpValidator', setErrorCurp)}
                            
                        />        
                        {
                            errorCurp && (
                                <FormError
                                    message={t('registration.validator.curp')}
                                />
                            )
                        }        
                    </div>
                    <div className="registrationFreelanceDataView-birth-place">
                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.brithplace")}
                            valueInput={birthPlace}
                            handleChangeInput={(e) => onChangeInput(e, setBirthPlace)}
                            // tooltipShow
                            // positionTooltip={'right'}
                            // titleTooltip={"Nombre completo"}
                            // descriptionTooltip={"Nombre"}
                            // subContent={''}
                            // informationIcon={true}
                            inputActive={true}                            
                        />            
                    </div>
                    <div className="registrationFreelanceDataView-nationality">
                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.nationality")}
                            valueInput={nationality}
                            handleChangeInput={(e) => onChangeInput(e, setNationality)}
                            // tooltipShow
                            // positionTooltip={'right'}
                            // titleTooltip={"Nombre completo"}
                            // descriptionTooltip={"Nombre"}
                            // subContent={''}
                            // informationIcon={true}
                            inputActive={true}                            
                        />           
                    </div>
                    <div className="registrationFreelanceDataView-date">
                        <span className="registrationFreelanceDataView-date">{t("registrationFreelanceDataView.date")}</span>
                        <Traslates>
                            <FormDatePicker
                                id={"date"}
                                name={"date"}
                                format="dd-MM-yyyy"
                                onChange={(e) => onChangeInput(e, setDate)}
                                value={date}
                            />
                        </Traslates>
                    </div>
                </div>
                <div className="registrationFreelanceDataView-right">
                    <TextAreaHLPure
                        labelTextArea={t('contractingRegistrationDataView.text.area.address.label')}
                        valueTextData={address}
                        handleChangeTextArea={(e) => onChangeInput(e, setAddress)}
                    />    
                    <div className="registrationFreelanceDataView-city">
                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.city")}
                            valueInput={city}
                            handleChangeInput={(e) => onChangeInput(e, setCity)}
                            tooltipShow={false}
                            informationIcon={false}
                            inputActive={true}
                        />
                    </div>
                    <div className="registrationFreelanceDataView-city">
                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.state")}
                            valueInput={state}
                            handleChangeInput={(e) => onChangeInput(e, setState)}
                            tooltipShow={false}
                            informationIcon={false}
                            inputActive={true}
                        />
                    </div>
                    <div className="registrationFreelanceDataView-city">
                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.cp")}
                            valueInput={cp}
                            handleChangeInput={(e) => onChangeInput(e, setCp)}
                            tooltipShow={false}
                            informationIcon={false}
                            inputActive={true}
                        />
                    </div>
                    <div className="registrationFreelanceDataView-passport">
                        <InputHLPure
                            typeInput="text"
                            labelInput={t("registrationFreelanceDataView.passport")}
                            valueInput={passport}
                            handleChangeInput={(e) => onChangeInput(e, setPassport)}
                            // tooltipShow
                            // positionTooltip={'right'}
                            // titleTooltip={"Nombre completo"}
                            // descriptionTooltip={"Nombre"}
                            // subContent={''}
                            // informationIcon={true}
                            inputActive={true}                            
                        />     
                    </div>
                    <div className="registrationFreelanceDataView-country">
                        <DropDownBtnHLPure
                            labelDropDown={t("registrationFreelanceDataView.passport.country")}
                            optionsDropDown={countriesList}
                            valueItem={"country"}
                            nameOption={"country"}
                            optionsValue={country}
                            onDropDownChange={(e) => onChangeInput(e, setCountry)}
                        />
                    </div>
                </div>
            </div>
            <div className="registrationFreelanceDataView-container-btns">
                <div className="registrationFreelanceDataView-btn-sec">
                    <ButtonHLPure
                        nameBtn={step.back}
                        primary={false}
                        onClickBtn={() => onHandleBack()}
                    />
                </div>
                <ButtonHLPure
                    nameBtn={step.next}
                    primary={true}
                    onClickBtn={() => handleSaveInfo()}
                />
            </div>
            <DialogSystemGLPure
                showLoadingRequesting={showLoadingRequesting}
                showCompletedRequesting={showCompletedRequesting}
                showErrorRequesting={showErrorRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}
                toggleErrorRequesting={toggleErrorRequesting}
                message={messageError}
            />
        </div>
    )
}

export { RegistrationFreelanceDataView as default}